<template>
  <MainLayout>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="text-uppercase">
          <span>{{ isEditPage ? $t('edit') : $t('create') }} {{ $t('segmentation_strategy') }}</span> <span v-b-tooltip.hover :title="tooltips.lines"><i class="fa fa-info-circle font-size-xMedium"></i></span>
        </h1>
      </div>
      <div class="d-flex">
        <Button
          class="btn btn-color10"
          v-b-modal.cancel-campaign-upsert-modal
        >
          {{ $t('cancel') }}
        </Button>
        <CancelCampaignUpsertModal
          :campaign="campaign"
          :segmentation="segmentation"
          :line="line"
          :step="isEditPage ? 'line' : 'package'"
        />
      </div>
    </div>
    <!-- CAMPAIGN LOADER -->
    <div v-if="campaignLoader" class="text-center mt-3">
      <Loader
        :size="'big'"
      />
    </div><!-- END CAMPAIGN LOADER -->
    <template v-else>
      <!-- PACKAGE FORM -->
      <div class="mt-3" v-if="!isEditPage || (isEditPage && line)">
        <!-- HEADING -->
        <section class="my-4">
          <div class="col-lg-10 mx-auto text-center">
            <p>{{ $t('configure_segmentation_strategy_campaign_group') }}</p>
          </div>
        </section> <!-- END HEADING -->
        <section class="">
          <div class="col-lg-10 mx-auto mb-5 position-relative">
            <div class="card">
              <div class="card-body">
                <CampaignLineForm
                  v-if="campaign"
                  :base-campaign="campaign"
                  :advertiser="campaign.advertiser"
                />
              </div>
            </div>
          </div>
        </section>
      </div><!-- END PACKAGE FORM -->
    </template>
  </MainLayout>
</template>

<script>

import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import variables from '@/mixins/variables'

import Button from '@/components/common/Button/Button'
import CampaignLineForm from '@/components/campaigns/Programatic/CampaignLineForm'
import CancelCampaignUpsertModal from '@/components/campaigns/Modals/CancelCampaignUpsertModal'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'

import { mapActions, mapState } from 'vuex'

export default {
  mixins: [variables],
  components: {
    Button,
    CampaignLineForm,
    CancelCampaignUpsertModal,
    Loader,
    MainLayout
  },
  data () {
    return {
      campaign: '',
      campaignLoader: false,
      line: '',
      loader: false,
      segmentation: ''
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  created () {
    this.getCampaign()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    /**
     * Check if is edit page
     */
    isEditPage () {
      return this.$route.name === 'lines.edit'
    },
    /**
     * Get page title
     */
    pageTitle () {
      return this.$route.name === 'lines.create' ? this.$t('create_strategy') : this.$t('edit_strategy')
    }
  },
  methods: {
    ...mapActions('campaigns', [
      'setCurrentCampaign'
    ]),
    /**
     * Get campaign
     */
    async getCampaign () {
      this.campaignLoader = true
      try {
        const campaign = await CampaignsService.getCampaign(this.$route.params.cId)
        if (campaign.status === 'FINISHED') return this.$router.push({ name: 'campaigns.show', params: { id: campaign.id } })
        this.campaign = campaign
        // If is create page, the package id is on the url
        this.segmentation = this.campaign.packages.find(item => {
          if (this.isEditPage) {
            return item.lines.find(line => {
              return line.id === this.$route.params.id
            })
          } else {
            return item.id === this.$route.params.pId
          }
        })
        //
        this.line = this.segmentation.lines.find(item => {
          return item.id === this.$route.params.id
        })
        // if (!this.segmentation || !this.line) return
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.$router.push('/')
      }
      this.campaignLoader = false
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .programatic-campaign-navigation {
      position: absolute;
      top: 0;
      left: -100px;
      z-index: 2;
      display: none;

      @include desktop {
        display: block;
      }
    }
  }

  .star-icon {
    width: 20px;
    height: 20px;
    display: flex;
    background: $color1;
    justify-content: center;
    align-items: center;
  }

  .text-none {
    text-transform: none;
  }
</style>
